import R from 'ramda'
import shallowEqual from 'fbjs/lib/shallowEqual'
import * as ANS from './action-names'
import createCustomActions, * as actions from './actions'
import createSelectors from './selectors'
import { fromNullable } from 'data.maybe'

export const addToSet = (set, item) =>
  R.findIndex(a => shallowEqual(a, item), set) >= 0 ? set : [...set, item]

export const createPasteDataReducer = dataMerge => (state, action) => {
  const { pasteData } = action.payload
  const pastedArray = Object.values(pasteData)

  return state.map(row => {
    const index = R.findIndex(
      ({ currentData }) => currentData === row,
      pastedArray
    )

    return index >= 0
      ? dataMerge({
          existingData: row,
          updateData: pastedArray[index].updateData,
        })
      : row
  })
}

export const createCommitEditReducer = commitDataMerge => (state, action) => {
  const { columnIndex, content, headers: colHeaders, rowData } = action.payload

  return state.map(row =>
    row !== rowData
      ? row
      : commitDataMerge({
          existingData: row,
          prop: colHeaders[columnIndex],
          value: content,
        })
  )
}

const capturePasteDirtyData = toKey => (state, payload) => {
  const { pasteData } = payload
  const pastedArray = Object.values(pasteData)
  const dirty = pastedArray.map(({ currentData }) => toKey(currentData))
  let finalDirty = state

  for (let i = 0; i < dirty.length; i++) {
    finalDirty = addToSet(finalDirty, dirty[i])
  }

  return finalDirty
}

const captureEditDirtyData = toKey => (state, payload) => {
  const key = toKey(payload.rowData)
  const dirty = addToSet(state, key)
  return dirty
}

export const createDirtyReducer = toKey => (state = [], action) => {
  switch (action.type) {
    case ANS.COMMIT_EDIT:
      return captureEditDirtyData(toKey)(state, action.payload)
    case ANS.PASTE_DATA:
      return capturePasteDirtyData(toKey)(state, action.payload)
    case ANS.SET_CONTENT:
      return []
    case ANS.CLEAR_DIRTY:
      return []
  }
  return state
}

export const createGridTools = customSelectors => {
  const selectors = createSelectors(fromNullable(customSelectors).getOrElse({}))
  const customActions = createCustomActions(selectors)
  return { ...selectors, ...actions, ...customActions }
}
